var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pluginstore-modal-flex"},[(!!_vm.$slots['body'])?[_vm._t("body")]:[(!!_vm.$slots['header'])?_c('header',{staticClass:"header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pluginstore-modal-main"},[_c('div',{staticClass:"pluginstore-modal-content"},[_vm._t("main")],2)])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }